import { Component, OnInit } from '@angular/core';
import { InputAutocompleteModel } from 'src/app/models/input-autocomplete.model';
import { AuthenticationService } from '../../../authentication/authentication/authentication.service';
import { CompanyRoleResponse } from 'src/app/models/company.model';
import { AdminDTEService } from 'src/app/services/admin.service';
import { DateUtil } from 'src/app/common/util';
import { ResponseObject } from 'src/app/models/response-object.model';
import { HttpErrorResponse } from '@angular/common/http';
import { HistoryDTEElement } from 'src/app/models/admin.model';
import { PaginationModel } from 'src/app/models/pagination.model';
import { CompanyService } from 'src/app/services/company.service';
import { UserSaved } from 'src/app/models/user.model';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-history-dte',
  templateUrl: './history-dte.component.html',
  styleUrls: ['./history-dte.component.scss']
})
export class HistoryDteComponent implements OnInit {
  companies = [];
  inputCompany = new InputAutocompleteModel("", false, false, "", "", "", "", [], []);
  pagination = new PaginationModel(0, 5, 0, 0, [], []);
  allCompanies = [];
  timeout = null;
  selected = null;
  startDate = "";
  endDate = "";
  filterWord = "";
  onlyErrors = false;
  items: HistoryDTEElement[] = [];
  user: UserSaved = null;

  constructor(
    private authService: AuthenticationService,
    private dteService: AdminDTEService,
    private companyService: CompanyService,
    private toastService: ToastrService
  ) {
    this.companies = JSON.parse(this.authService.getCurrentUser()).companyRoles;
    this.user = this.authService.getUser();
    this.allCompanies = this.companies;
    var today = new Date();
    this.endDate = today.toLocaleDateString('en-CA');
    today.setDate(1);
    this.startDate = today.toLocaleDateString('en-CA');
  }

  ngOnInit(): void {
    this.getHistory();
    if (this.user.contadorGT) {
      this.getAssociatedCompanies();
    }
  }

  getAssociatedCompanies() {
    this.companyService.getCompaniesAssociatedToPartner(this.user.id).subscribe({
      next: (response: ResponseObject) => {
        this.companies = response.data;
        this.allCompanies = this.companies;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener las companias asociadas");
      }
    })
  }

  getHistory() {
    var companyId = this.selected ? this.selected.companyId : null;
    this.dteService.getHistoryDTE(
      companyId,
      DateUtil.parseDateToMilliseconds(this.startDate),
      DateUtil.parseDateToMilliseconds(this.endDate),
      this.onlyErrors,
      this.user.contadorGT
    ).subscribe({
      next: (response: ResponseObject) => {
        this.items = response.data as HistoryDTEElement[];
        this.filterByWord();
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      }
    })
  }

  filterByWord() {
    this.pagination.total = this.items.filter((item) => {
      var val = this.filterWord.toLowerCase();
      return !val || item.companyName?.toLowerCase().includes(val) || item.fileName?.toLowerCase().includes(val)
        || item.nitEmisor?.toLowerCase() == val || item.nitReceptor?.toLowerCase() == val || item.serie?.toLowerCase() == val
        || item.number == val || item.zipFileName?.toLowerCase().includes(val) || item.errorMessage?.toLowerCase().includes(val)
    });
    this.resetPagination(this.pagination);
  }

  filter() {
    if (this.startDate && this.endDate) {
      this.getHistory();
    }
  }

  searchCompany() {
    clearTimeout(this.timeout);
    this.inputCompany.class = "typing";
    this.selected = null;
    this.timeout = setTimeout(() => {
      this.companies = this.allCompanies.filter((company) => {
        var val = this.inputCompany.value.toLowerCase();
        return company.alphanumericId.toLowerCase() == val || company.companyName?.toLowerCase().includes(val) || company.companyNIT?.toLowerCase().includes(val)
        || company.name?.toLowerCase().includes(val) || company.nit?.toLowerCase().includes(val);
      });
      this.inputCompany.verified = false;
      if (this.companies.length > 0) {
        this.inputCompany.class = "fa-list";
      } else {
        this.inputCompany.class = "fa-xmark";
      }
      if (!this.inputCompany.value.toLowerCase()) {
        this.selected = null;
        this.filter();
      }
    }, 300);
  }

  selectCompany(selected: CompanyRoleResponse) {
    clearTimeout(this.timeout);
    this.inputCompany.value = selected.alphanumericId + " - " + selected.companyNIT + " - " + selected.companyName;
    this.inputCompany.verified = true;
    this.inputCompany.class = "fa-circle-check";
    this.selected = selected;
    this.filter();
  }

  resetPagination(paginationTemp) {
    paginationTemp.startElement = 0;
    paginationTemp.pageIndex = 0;
    paginationTemp.lastElement = paginationTemp.pageSize;
    paginationTemp.filter = paginationTemp.total.slice(paginationTemp.startElement, paginationTemp.lastElement);
    paginationTemp.lastElement = paginationTemp.filter.length;
  }
}
